import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import classNames from 'classnames'

import CrossFade from '@components/blocks/components/cross_fade'
import RenderLargeUp from '@components/responsive/render_large_up'
import RenderSmallDown from '@components/responsive/render_small_down'
import styles from '@components/blocks/testimonials_block.module.scss'

const TestimonialsResponsiveContent = ({ testimonialBlocks, testimonials }) => {
  const [selectedTestimonialTab, setSelectedTestimonialTab] = useState(testimonials[0])
  const [testimonialSlideIndex, setTestimonialSlideIndex] = useState(0)

  const getTestimonialTabs = () => {
    return (
      <ul className={styles.testimonials_block__tab_list}>
        {testimonials.map(testimonial => {
          const tabClasses = [styles.testimonials_block__tab_button]
          if (testimonial.id === selectedTestimonialTab.id) {
            tabClasses.push(styles['testimonials_block__tab_button--active'])
          }

          return (
            <li className={styles.testimonials_block__tab} key={testimonial.id}>
              <button
                className={classNames(tabClasses)}
                onClick={() => setSelectedTestimonialTab(testimonial)}
              >
                {testimonial.fields.title}
              </button>
            </li>
          )
        })}
      </ul>
    )
  }

  return (
    <div className={styles.testimonials_block__testimonials}>
      <RenderSmallDown>
        <Swiper onSlideChange={swiper => setTestimonialSlideIndex(swiper.activeIndex)}>
          {Object.values(testimonialBlocks).map((testimonial, index) => (
            <SwiperSlide key={index}>{testimonial}</SwiperSlide>
          ))}
        </Swiper>
        <div className={styles.slide_indicators}>
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={classNames('slide_indicators__dot', {
                'slide_indicators__dot--active': index === testimonialSlideIndex,
              })}
              onClick={() => setTestimonialSlideIndex(index)}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>
      </RenderSmallDown>
      <RenderLargeUp>
        {getTestimonialTabs()}
        <CrossFade>{testimonialBlocks[selectedTestimonialTab.id]}</CrossFade>
      </RenderLargeUp>
    </div>
  )
}

export default TestimonialsResponsiveContent
